module.exports = __webpack_public_path__ + "img/banner2.bd28b6f7.jpg";